import { type FloatingPosition, HoverCard } from '@any-ui-react/core';
import classNames from 'classnames';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  defaultOpened?: boolean;
  disabled?: boolean;
  hoverCardContent: ReactNode;
  position?: FloatingPosition;
  hideUnderline?: boolean;
}

export const HoverCardWithText = ({
  children,
  defaultOpened = false,
  disabled,
  hoverCardContent,
  position,
  hideUnderline,
}: Props) => {
  if (disabled || !hoverCardContent || (typeof hoverCardContent === 'string' && hoverCardContent.trim() === '')) {
    return children;
  }

  return (
    <HoverCard
      classNames={{ dropdown: 'px-2 py-1 bg-gray-7 text-white' }}
      defaultOpened={defaultOpened}
      keepMounted={defaultOpened}
      position={position}
      withArrow={true}
      withinPortal={true}
    >
      <HoverCard.Target>
        <span
          className={classNames('cursor-help', {
            'underline decoration-dotted decoration-gray-7 underline-offset-4': !hideUnderline,
          })}
        >
          {children}
        </span>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <div className="max-w-xs text-2xs">{hoverCardContent}</div>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
